import {
    configureStore,
} from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import searchSlice from './slices/searchSlice';
import contactSlice from './slices/contactSlice';
import registrationSlice from './slices/registrationSlice';
import authSlice from './slices/authSlice';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const persistConfig = {
    key: 'root',
    storage,
};
const persistedReducer = persistReducer(persistConfig, searchSlice);
const contactReducer = persistReducer(persistConfig, contactSlice);
const registrationReducer = persistReducer(persistConfig, registrationSlice);
const authReducer = persistReducer(persistConfig, authSlice);

export const store = configureStore({
    reducer: {
        search: persistedReducer,
        contact: contactReducer,
        registration: registrationReducer,
        authentication: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);